<script>
import bus from 'AssetEditor/AssetEditorEventBus';
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default Vue.extend({
  computed: {
    ...mapState('assetEditor', ['currentPageId']),
    ...mapGetters('assetEditor', [
      'assetModel',
      'AGD',
      'story',
      'workModel',
      'isTempAgdDirty',
    ]),
    ...mapGetters(['hasAudioOnTimeline']),

    storyBgMusic() {
      return this.story.bgMusic;
    },

    isPaceNormal() {
      const agd = this.AGD;
      return (agd && (+agd.videoSpeed || 1)) === 1;
    },

    isFragment() {
      return this.assetModel.isSOCIALFRAGMENT() || this.assetModel.isFRAGMENT();
    },

    hasValidAudio() {
      return this.assetModel.get('hasValidAudio');
    },

    showVolumeDualSettings() {
      return this.story.showVolumeDualSettings;
    },

    hasNarration() {
      return null; // TODO: zendive: getAudioTracksUnderVisual
    },

    hasOverlayTracks() {
      return (
        this.workModel.overlayTracks && this.workModel.overlayTracks.length > 0
      );
    },

    canMix() {
      return this.hasValidAudio && this.isPaceNormal;
    },

    hasBG() {
      return !!this.storyBgMusic;
    },

    canEditVideoVolume() {
      return this.isFragment && this.canMix;
    },
  },

  mounted() {
    bus.$on('backToPreview', this.backToPreviewWrapper);
    app.keyboardAccessibility.add(app.KEYBOARD_LAYER.BTP, [
      {
        on: 'keydown',
        key: $.ui.keyCode.ESCAPE,
        inEditor: true,
        run: this.$_onEscape.bind(this),
      },
    ]);
  },

  beforeDestroy() {
    bus.$off('backToPreview', this.backToPreviewWrapper);
    app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.BTP);
  },

  methods: {
    ...mapActions('assetEditor', ['changeCurrentPage']),

    $_onEscape() {
      const escapeOnPreview = this.currentPageId === 'preview';

      if (escapeOnPreview) {
        bus.$emit('cancel');
      } else {
        this.changeCurrentPage('preview');
      }
    },

    backToPreviewWrapper() {
      app.analytics('analytics.scenes.internalPageExit', { using: 'Back' });
      this.backToPreview();
    },

    /**
     * @param isDirty {Boolean}
     * @param [beforeApply] {Function} optional gate - resolve false to abort
     *        the save and keep the user on the current page
     */
    askSaveChanges(isDirty = false, beforeApply = null) {
      if (!isDirty) {
        this.changeCurrentPage('preview');
        return Promise.resolve();
      }
      return app.dialog
        .confirm(
          {
            type: app.dialog.types.CONFIRM_2,
            buttonNoText: 'No',
            title: 'Save changes?',
          },
          {
            wrapperStyle: {
              zIndex: 2055,
            },
          }
        )
        .then((data) => {
          if (
            (data.e.currentTarget.classList &&
              data.e.currentTarget.classList.contains('wt2-close')) ||
            data.e.key === 'Escape'
          ) {
            return Promise.reject('Modal was closed by user');
          }

          app.analytics('analytics.scenes.confirmBack', {
            save: !!data.action,
          });

          if (!data.action) {
            this.changeCurrentPage('preview');
            return;
          }

          return Promise.resolve(beforeApply ? beforeApply() : true).then(
            (canApply) => {
              if (canApply) {
                bus.$emit('apply-click');
              }
            }
          );
        });
    },
  },
});
</script>
